module.exports = __webpack_public_path__ + "static/media/applewallet.0b5b9bd4.svg";